export default "__VITE_ASSET__8b805606__"